export const LOCAL_AB_ICON_NAMES = [
  "download",
  "pdfFile",
  "tel",
  "email",
  "plus",
  "minus",
  "arrowRight",
  "sliderArrowLeft",
  "sliderArrowRight",
  "quote",
  "arrowLeftBig",
  "arrowRightBig",
  "chevronRight",
  "chevronLeft",
  "check",
  "done-in-circle",
  "info-mark",
  "ic",
  "play"
];
